import request from "@/utils/request";

export function personList(data: any) {
  return request({
    url: "/project/mobile/accessRecord/page",
    method: "get",
    params: data,
  });
}
